var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.898 8.97125L19.2966 3.45367C18.8766 3.03992 18.3195 2.8125 17.7269 2.8125H11.9073C8.58375 2.8125 5.87952 5.47625 5.87952 8.75V21.25C5.87952 24.5238 8.58375 27.1875 11.9073 27.1875H19.5212C22.8447 27.1875 25.549 24.5238 25.549 21.25V10.5174C25.549 9.93368 25.318 9.38375 24.898 8.97125ZM19.204 6.01257L22.2991 9.06128H21.4247C20.2001 9.06128 19.204 8.08003 19.204 6.87378V6.01257ZM19.5212 25.3125H11.9073C9.63321 25.3125 7.78301 23.49 7.78301 21.25V8.75C7.78301 6.51 9.63321 4.6875 11.9073 4.6875H17.3005V6.875C17.3005 9.115 19.1507 10.9375 21.4247 10.9375H23.6455V21.25C23.6455 23.49 21.7953 25.3125 19.5212 25.3125Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.b5e09d3a.svg";
export { ForwardRef as ReactComponent };